import PropTypes from 'prop-types';

import {
  Box,
  useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui';

/**
 * Finished-good simple PDP "what's included" via longDescription.
 */
export function FinishedGoodSimpleDescription({product}) {
  const styles = useMultiStyleConfig('FinishedGoodView', {});
  const raw = product?.longDescription ?? product?.c_longDescription;
  const html =
    typeof raw === 'string' ? raw :
      (raw && typeof raw === 'object' && typeof raw.source === 'string' ? raw.source : '');

  if (!html) return null;

  return (
    <Box
      className="finished-good-view__simple-description"
      {...styles.optionsList}
      dangerouslySetInnerHTML={{__html: html}}
    />
  );
}

FinishedGoodSimpleDescription.displayName = 'FinishedGoodSimpleDescription';

FinishedGoodSimpleDescription.propTypes = {
  product: PropTypes.object.isRequired,
};
